import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CameraService {

  constructor() { }

  /**
   * Verifica se a câmera tem permissões e solicita acesso, se necessário.
   * @returns Promise<boolean> - Retorna `true` se a permissão foi concedida, `false` caso contrário.
   */
  async checkCameraPermissions(): Promise<boolean> {
    try {
      // Tenta acessar a câmera
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      // Libera a câmera após a verificação
      stream.getTracks().forEach(track => track.stop());

      console.log('Permissão da câmera concedida.');
      return true;
    } catch (error) {
      console.error('Erro ao acessar a câmera:', error);

      // Verifica o tipo de erro
      if (error instanceof DOMException) {
        switch (error.name) {
          case 'NotAllowedError':
            console.error('Permissão da câmera negada pelo usuário.');
            break;
          case 'NotFoundError':
            console.error('Nenhuma câmera encontrada.');
            break;
          case 'NotReadableError':
            console.error('A câmera não pode ser acessada (pode estar em uso por outro aplicativo).');
            break;
          case 'OverconstrainedError':
            console.error('As restrições de configuração da câmera não podem ser atendidas.');
            break;
          default:
            console.error('Erro desconhecido ao acessar a câmera:', error.message);
        }
      }

      return false;
    }
  }
}